import { ReactNode } from 'react';
import { HeaderProvider } from '../../contexts/HeaderProvider';
import { Box, Grid2, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { BottomDrawer } from '../BottomDrawer';
import { MobileHeader } from './MobileHeader';

interface MobileLayoutProps {
  menuItems: (onMenuItemClick?: () => void) => ReactNode;
  breadcrumb?: string;
}
export const MobileLayout = ({ menuItems, breadcrumb }: MobileLayoutProps) => {
  const theme = useTheme();
  return (
    <HeaderProvider>
      <Grid2 container sx={{ width: '100vw', height: '100vh' }}>
        <Grid2
          size={12}
          sx={{
            height: '100px',
            position: 'sticky',
            top: 0,
            zIndex: 1301,
            backdropFilter: 'blur(10px)',
            boxShadow: `0px 12px 16px -4px ${theme.palette.shadows.dark}`,
          }}
        >
          <MobileHeader menuItems={menuItems} breadcrumb={breadcrumb} />
        </Grid2>
        <Grid2 size={12} sx={{ height: `calc(100vh - 200px)` }}>
          <Box
            id="scroll-container"
            flex={1}
            sx={{
              background: theme.palette.grey[50],
              overflow: 'auto',
              pt: theme.spacing(9),
              px: theme.spacing(2),
              mt: '-100px',
            }}
          >
            <Outlet />
          </Box>
        </Grid2>
        <Box sx={{ position: 'fixed', bottom: 0, left: 0, height: '100px' }}>
          <BottomDrawer />
        </Box>
      </Grid2>
    </HeaderProvider>
  );
};
